import { DashboardResultsTableItemProps } from './DashboardResultsTableItem.types';

export default ({ children, isHigher, isActive, ...props }: DashboardResultsTableItemProps) => {
  return (
    <td
      {...props}
      className={`${isHigher ? `dashboard__result-table-item--highlighted` : ''}
       ${isActive ? ' dashboard__result-table-item--active' : ''}`}>
      {children}
    </td>
  );
};
